// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.okse",
    name: "Okse Wallet",
    homepage: "https://okse.io",
    image_id: "8a1b36d5-7f40-403a-7000-5d30f9181200",
    app: {
        browser: "https://okse.io",
        ios: "https://apps.apple.com/us/app/okse-wallet-card/id1555914591",
        android: "https://play.google.com/store/apps/details?id=wallet.okse.io",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "oksewallet://",
        universal: "https://okse.io/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map